import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCabalRadar } from "./api";

const SEEN_KEY = "alphaapeing_cabal_seen";

export const getCabalSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markCabalSeen = (mints) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify(mints || []));
  window.dispatchEvent(new Event("cabal-seen-updated"));
};

export const useCabalAlerts = () => {
  const q = useQuery({ queryKey: ["cabalRadar"], queryFn: fetchCabalRadar, refetchInterval: 30000 });
  const mints = useMemo(() => (q.data?.loads || []).map((l) => l.tokenMint), [q.data]);

  const [seen, setSeen] = useState(getCabalSeen);
  useEffect(() => {
    const h = () => setSeen(getCabalSeen());
    window.addEventListener("cabal-seen-updated", h);
    return () => window.removeEventListener("cabal-seen-updated", h);
  }, []);

  const newCount = mints.filter((m) => !seen.has(m)).length;
  return { newCount, mints };
};
